import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import NavBar from "../../../components/AdminNavBar";
import { useStoreActions, useStoreState } from "../../../store";
import ComingSoonModal from "../../../components/ComingSoonModal";

type Props = {};

const Root = styled("div")(`
    display: flex;
    flex-direction: column; 
    height: 100vh;
    background: white;
`);

const DashboardContainer = (props: Props) => {
  const modalState = useStoreState((state) => state.modals);
  const modalActions = useStoreActions((actions) => actions.modals);

  return (
    <Root>
      <div className="flex flex-1 overflow-hidden">
        <div className="flex">
          <NavBar />
        </div>
        <div className="flex flex-1 flex-col">
          <div className="flex flex-1 overflow-y-auto">
            <Outlet />
          </div>
          <ComingSoonModal
            modalStatus={modalState.showSupportModal}
            closeModal={() => modalActions.setShowSupportModal(false)}
          />
        </div>
      </div>
    </Root>
  );
};

export default DashboardContainer;
